// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__RcwYg","dark":"ButtonLink_dark__lafYC"};